"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getMapTypes = void 0;

var _kubraKmap = _interopRequireDefault(require("kubra-kmap"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} //  This is ordered in the toggle order.


var getMapTypes = function getMapTypes() {
  return [{
    name: 'Road',
    type: _kubraKmap.default.mapType.google.ROAD
  }, {
    name: 'Satellite',
    type: _kubraKmap.default.mapType.google.SATELLITE
  }, {
    name: 'Hybrid',
    type: _kubraKmap.default.mapType.google.HYBRID
  }];
};

exports.getMapTypes = getMapTypes;

var _default = getMapTypes();

exports.default = _default;